window.SiteReady(($) => {

  console.log('Init Block: Brochure');

  const $tabs = $('.js-brochure_filter_tab');

  $tabs.each((_, tab) => {
    const $tab = $(tab);

    if ($tab.attr('href') === window.location.hash) {
      $tab.attr('data-swap-active', 'true');
    }
  });

  // swap() activates the initial tab straight away, which can be before
  // pills.js has defined refreshPills: block scripts load as modules and run
  // as soon as the DOM is parsed, ahead of pills.js's own SiteReady callback.
  // pills.js positions every pill itself once it initializes.
  $tabs.on('swap:activate', () => {
    if (typeof window.refreshPills === 'function') {
      window.refreshPills();
    }
  });

  $tabs.swap({
    collapse: false,
    classes: {
      active: 'active'
    }
  });

});
